module.exports = __webpack_public_path__ + "mn.svg?fe5a69c8e47626f17e4de358a447b2a2";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mn.svg
// module id = 1129
// module chunks = 27